import { GoogleOAuthProvider } from "@react-oauth/google";
import React from "react";
import ReactDOM from "react-dom/client";
import { Toaster as HotToaster } from "react-hot-toast";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { initSentry } from "./helpers/sentry";
import reportWebVitals from "./reportWebVitals";
import "./styles/index.css";

// Initialize Sentry BEFORE rendering React to catch all errors
initSentry();

window["initMaps"] = function () {};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId="YOUR_GOOGLE_CLIENT_ID">
      <BrowserRouter future={{ v7_startTransition: true }}>
        <HotToaster />
        <App />
      </BrowserRouter>
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
